module.exports = __webpack_public_path__ + "images/12e76616b578bf8afa24d1e021b634a73.png";